<template>
    <div>
        <div class="row">
            <div class="col-xs-12 search_type">
                <ul class="nav nav-tabs text-center">
                    <li :class="{ active: isSearchTypeRooms === false }">
                        <a href="#" @click.prevent="changeType('imoveis')">Imóveis Inteiros</a>
                    </li>
                    <li :class="{ active: isSearchTypeRooms === true }">
                        <a href="#" @click.prevent="changeType('quartos')">Quartos</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    computed: {
        isSearchTypeRooms() {
            return this.search_type === 'quartos';
        },
        search_type() {
            return this.$store.state.search_type;
        },
        location() {
            return this.$store.getters.getCitySlug;
        },
        view() {
            return this.$store.state.view;
        }
    },
    methods: {
        changeType(type) {
            let url = '/busca';
            if (this.view === 'map') {
                url = '/busca-mapa';
            }

            if (type != '' && typeof type != 'undefined')
                url = url + '/' + type;
            if (this.location != '' && typeof this.location != 'undefined')
                url = url + '/' + this.location;

            const districts = this.$store.getters.getSelectedDistricts;
            if (districts && districts.length) {
                url += '/' + districts.join(',');
            }

            location.href = url;
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
.search_type {
    .search_type .nav-tabs > li.active > a {
        color: inherit;
        border: none;
    }
    ul {
        display: flex;
        justify-content: center;
        li {
            a {
                text-transform: none;
                font-size: 16px;
                border: none;
                border-bottom: 2px solid transparent;

                &:hover, &:focus {
                    background: transparent !important;
                    border: none;
                    border-bottom: 2px solid $brand-custom !important;
                    color: #313a46 !important;
                }
            }

            &.active, &:hover {
                border: none
            }

            &.active a {
                color: #313a46;
                background: transparent;
                border: none;
                border-bottom: 2px solid $brand-custom;
            }

            &.active a:hover, &.active a:focus {
                color: #313a46;
                background: transparent;
                border: none;
                border-bottom: 2px solid $brand-custom;
            }
        }
    }
}
</style>